if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.prevButton = this.querySelector('[id^="ModalPrev-"]');
        this.nextButton = this.querySelector('[id^="ModalNext-"]');
        if (this.prevButton) {
          this.prevButton.addEventListener('click', this.showPreviousMedia.bind(this));
          this.prevButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', this.showNextMedia.bind(this));
          this.nextButton.addEventListener('pointerup', (event) => event.stopPropagation());
        }
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ARROWRIGHT') this.showNextMedia();
          if (event.code.toUpperCase() === 'ARROWLEFT') this.showPreviousMedia();
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.activeMediaId = opener.getAttribute('data-media-id');
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content [data-media-id]'));
      }

      showActiveMedia() {
        const mediaItems = this.getMediaItems();

        mediaItems.forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === this.activeMediaId);
        });

        const activeMedia = this.querySelector(`[data-media-id="${this.activeMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showNextMedia() {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;
        const currentIndex = mediaItems.findIndex((element) => element.getAttribute('data-media-id') === this.activeMediaId);
        const nextItem = mediaItems[(currentIndex + 1) % mediaItems.length];
        this.activeMediaId = nextItem.getAttribute('data-media-id');
        window.pauseAllMedia();
        this.showActiveMedia();
      }

      showPreviousMedia() {
        const mediaItems = this.getMediaItems();
        if (mediaItems.length < 2) return;
        const currentIndex = mediaItems.findIndex((element) => element.getAttribute('data-media-id') === this.activeMediaId);
        const previousItem = mediaItems[(currentIndex - 1 + mediaItems.length) % mediaItems.length];
        this.activeMediaId = previousItem.getAttribute('data-media-id');
        window.pauseAllMedia();
        this.showActiveMedia();
      }
    }
  );
}
